import React, { FC, useContext } from "react";
import { TabContent, TabPane, NavItem, NavLink } from "reactstrap";
import cn from "clsx";
import { useAppSelector } from "@/redux/store";
import useActiveSizeTypeSizes from "@/components/product/hooks/useActiveSizeTypeSizes";
import { selectProductSizes, selectProductSizeTypes } from "../../selectors";
import ProductSizeList from "./productSizeList";
import SizeHeadSection from "./sizeHeadSection";
import { MobileSizesContext } from "../productMobileSizes";

const ProductMultiSize: FC<any> = ({ activeSizeType }) => {
  const productSizes = useAppSelector(selectProductSizes);
  const productSizeTypes = useAppSelector(selectProductSizeTypes);
  const activeTypeSizes = useActiveSizeTypeSizes(productSizes, activeSizeType);
  const {
    showProductSizeChart,
    onSizeTypeSelection,
    selectedSizeFullData: { sizeType: selectedSizeType }
  } = useContext(MobileSizesContext);

  return (
    <div className="mobile_size_wrapper">
      <SizeHeadSection showProductSizeChart={showProductSizeChart}>
        <ul className="buttonsMultiSizeTabs">
          {productSizeTypes?.map((sizeType: TextAttributeField) => {
            const { key: sizeTypeKey, label } = sizeType;
            return (
              <NavItem key={sizeTypeKey}>
                <NavLink
                  className={cn({
                    active: activeSizeType.key === sizeTypeKey
                  })}
                  onClick={() => {
                    onSizeTypeSelection(sizeType);
                  }}
                >
                  <span>{label}</span>
                </NavLink>
              </NavItem>
            );
          })}
        </ul>
      </SizeHeadSection>
      <div className="multiSizeTabsContent">
        <TabContent activeTab={activeSizeType.key}>
          {productSizeTypes?.map((sizeType: TextAttributeField) => (
            <TabPane tabId={sizeType.key} key={sizeType.key}>
              <ProductSizeList
                productSizes={activeTypeSizes}
                isMultipleSize
                isActive={selectedSizeType.key === sizeType.key}
              />
            </TabPane>
          ))}
        </TabContent>
      </div>
    </div>
  );
};

export default ProductMultiSize;
